export default __webpack_public_path__ + "static/media/me3_Heart_Outline_Icon.6c54146b.svg";